module.exports = __webpack_public_path__ + "static/media/za.14e70522.svg";